import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import { TypeAnimation } from 'react-type-animation'

const HealthcareMainBanner = () => {
    const { t } = useLanguage();
  return (
    <div id='website-responsive'>
    <div className='bg-img padding-faq' style={{ backgroundImage:"url('/healthcare/ZM-Health-care-banner.webp')", height:'', width:'100%', }}>
        <div className=''>
            <h3 className='fs-ss-24 text-mulish text-white fw-500' style={{ letterSpacing:'1px'}}>
                {t('healthcare.bannerSubtitle')}
            </h3>
        </div>
        <div className=' mt2'>
            {/* <span className='fs-ss-70 text-ss-primary text-philos'> */}
                <TypeAnimation sequence={[t('healthcare.title'),1000,'',200]}
                wrapper="span"
                speed={1}
                deletionSpeed={0}
                className='fs-ss-60 textss-primary fw-800 text-philos ms-lg-2 ms-1 ms-md4'
                style={{color:'#FE9B1F' }}
                repeat={Infinity}
                cursor={false} />
           
        </div>
    </div>
    </div>
  )
}

export default HealthcareMainBanner